module.exports = __webpack_public_path__ + "img/buys.e4dbc240.jpg";